import { render, staticRenderFns } from "./MyCompanyPrintersLocationsNew.vue?vue&type=template&id=06ad3729&"
import script from "./MyCompanyPrintersLocationsNew.vue?vue&type=script&lang=js&"
export * from "./MyCompanyPrintersLocationsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports